import { SHOW_CYCLE_GUIDE, showcases } from 'core';
import { Container, ProductListSkeleton } from 'ui/components';
import { useGetFeatureFlag } from 'ui/hooks';

import ProductShowcase from '../Products/ProductShowcase';
import ProductsShowcasesEmpty from '../ProductsEmpty/ProductsEmpty';
import CycleGuide from './CycleGuide/CycleGuide';
import CycleHighlights from './CycleHighlights/CycleHighlights';
import TipsAndTraining from './TipsAndTraining/TipsAndTraining';

export const ProductsShowcasesWidget = () => {
  const { allShowcasesAreFetched, isError, isIdle } = showcases.hooks.useShowcasesAvailable();

  const {
    data: { formattedShowcasesData, allFormattedEmptyOrUnavailable },
    isLoading,
  } = showcases.hooks.useShowcases();

  const { value: showCycleGuide, loading: cycleGuideLoading } = useGetFeatureFlag(
    SHOW_CYCLE_GUIDE,
    false,
  );

  const positions = {
    cycleHighlights: 3,
    tipsAndTraining: 4,
  };

  const filteredShowcases = formattedShowcasesData
    .filter(({ data }) => data.length > 0)
    .filter((showcase) => showcase.order > -10);

  const canShowErrorBanner =
    allShowcasesAreFetched &&
    (isError || (allFormattedEmptyOrUnavailable && !isLoading && !isIdle));

  const canShowShowcases =
    allShowcasesAreFetched && !allFormattedEmptyOrUnavailable && !cycleGuideLoading;

  const renderShowcases = () => {
    const hasLessThanTwoShowcases = filteredShowcases.length < 2;

    return (
      <>
        {filteredShowcases.map(({ data, tagName, name }, i) => (
          <div key={tagName}>
            <ProductShowcase
              key={`${tagName}`}
              data={data}
              tagName={tagName}
              name={name}
              showcaseIndex={i}
            />
            {(hasLessThanTwoShowcases || i === 0) && showCycleGuide && <CycleGuide />}
            {i === positions.cycleHighlights && <CycleHighlights />}
            {i === positions.tipsAndTraining && <TipsAndTraining />}
          </div>
        ))}

        {filteredShowcases.length < 1 && showCycleGuide && <CycleGuide />}

        {hasLessThanTwoShowcases && (
          <>
            <CycleHighlights />
            <TipsAndTraining />
          </>
        )}
      </>
    );
  };

  if (canShowErrorBanner && !Object.keys(filteredShowcases).length) {
    return (
      <>
        <ProductsShowcasesEmpty />
        <CycleGuide />
        <CycleHighlights />
        <TipsAndTraining />
      </>
    );
  }

  if (canShowShowcases) {
    return renderShowcases();
  }

  return (
    <Container fluid marginTop="sp-2" dataTestid="container-loading">
      <ProductListSkeleton itemsPerRowDesktop={4} />
    </Container>
  );
};

export default ProductsShowcasesWidget;
